module.exports = __webpack_public_path__ + "static/media/thumb.2f6308c1.png";